var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloud(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 191.927 191.927",
    xmlSpace: "preserve",
    fill: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#010002"
    },
    points: "128.613,116.799 95.967,84.153 63.321,116.799 65.915,119.394 94.131,91.175 94.131,169.673 97.803,169.673 97.803,91.178 126.015,119.394 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#010002"
    },
    d: "M146.597,59.445c-6.914-11.531-19.383-18.635-32.868-18.635c-3.089,0-6.199,0.387-9.262,1.152 c-6.778-12.193-19.465-19.709-33.466-19.709c-20.603,0-37.46,16.341-38.272,36.934C13.961,61.918,0,77.94,0,97.094 c0,21.13,17.189,38.319,38.319,38.319H76.58v-3.579H38.326c-19.158,0-34.74-15.586-34.74-34.74 c0-17.844,13.367-32.696,31.093-34.543l1.593-0.372v-1.61c0-19.154,15.582-34.736,34.736-34.736 c13.131,0,24.991,7.297,30.957,19.039l0.673,1.321l1.421-0.412c3.196-0.927,6.446-1.396,9.674-1.396 c12.619,0,24.268,6.871,30.395,17.934l0.648,1.167l1.303-0.286c22.268-4.914,42.273,12.279,42.273,33.895 c0,19.15-15.582,34.74-34.74,34.74H115.06v3.579h38.548c21.13,0,38.319-17.189,38.319-38.319 C191.927,73.667,170.607,54.957,146.597,59.445z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloud);
export default __webpack_public_path__ + "static/media/cloud.cd0d101d8cbddda665766df9887b40fe.svg";
export { ForwardRef as ReactComponent };